import {useQuery} from "@tanstack/react-query";
import {readYearlyRevenue} from "../../../../../api/main/SalesApi";
import {SalesSearchParamType} from "../interface";
import {salesYearlyMapInit} from "../state";

interface Props {
    param: SalesSearchParamType
    enabled: boolean
}

export const useReadYearlyRevenue = ({param, enabled}: Props) => {
    const {data} = useQuery({
        queryKey: ["readYearlyRevenue", param],
        queryFn: async () => await readYearlyRevenue(param),
        select: (res) => res?.data.result?.searchYearlyRevenueRes ?? salesYearlyMapInit,
        enabled: enabled
    });

    return {data};
};
